import { forwardRef } from 'react';

import { IconProps } from '.';

export const ArrowLeftSmallIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        d="M12.49 6.92003L11.76 6.19003C11.6457 6.07645 11.4911 6.0127 11.33 6.0127C11.1689 6.0127 11.0143 6.07645 10.9 6.19003L7.52 9.57003C7.46254 9.62594 7.41688 9.6928 7.3857 9.76665C7.35451 9.84051 7.33845 9.91986 7.33845 10C7.33845 10.0802 7.35451 10.1596 7.3857 10.2334C7.41688 10.3073 7.46254 10.3741 7.52 10.43L10.9 13.81C11.0143 13.9236 11.1689 13.9874 11.33 13.9874C11.4911 13.9874 11.6457 13.9236 11.76 13.81L12.49 13.08C12.6012 12.9645 12.6633 12.8104 12.6633 12.65C12.6633 12.4897 12.6012 12.3356 12.49 12.22L10.27 10L12.49 7.78003C12.6012 7.66451 12.6633 7.51039 12.6633 7.35003C12.6633 7.18967 12.6012 7.03555 12.49 6.92003Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default ArrowLeftSmallIcon;
